function isFileSizeSmallerThan(file, maxSizeMB) {
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  return file.size < maxSizeBytes;
}

export default isFileSizeSmallerThan;
